import React from 'react';
import * as PropTypes from "prop-types";
import FormBuilder from "../components/FormikBuilder";
import InputTimeBuilder from '../components/FormikBuilder/InputTimeBuilder';
import moment from 'moment';
import * as Yup from 'yup';


function SplitTempPendency(props) {
    const {data, dateTime, onSubmit, onCancel, ...other} = props;
    data.horaInicio = moment(data.dataHoraInicio).isValid() ? moment(data.dataHoraInicio).format('HH:mm') : null;
    data.horaFim = moment(data.dataHoraFim).isValid() ? moment(data.dataHoraFim).format('HH:mm') : null;
    data.horaDivisao = null
    return (
        <FormBuilder
            key={'player'}
            data={data}
            validationSchema={Yup.object().shape({
                horaInicio: Yup.string()
                    .required('Required'),
                horaDivisao: Yup.string()
                    .required('Required'),
                horaFim: Yup.string()
                    .required('Required'),
            })}
            schema={() => ({
                actions: [
                    {
                        label: 'Cancelar',
                        props: {
                            key: 'cancel',
                            type: 'button',
                        },
                        sizes: {
                            sm: 4,
                            xs: 4,
                        },
                    },
                    {
                        label: 'Dividir',
                        props: {
                            key: 'submit',
                            type: 'submit',
                            variant: 'outlined',
                        },
                        sizes: {
                            sm: 4,
                            xs: 4,
                        },

                    }
                ]
            })}
            onSubmit={onSubmit}
            onCancel={onCancel}
            {...other}
        >
            {
                (form, props) => {

                    return (<>
                        <InputTimeBuilder
                            form={form}
                            formProps={props}
                            fieldSchema={{
                                label: 'Início',
                                field: 'horaInicio',
                                sizes: {
                                    xs: 12,
                                    md: 4,
                                },
                                format: 'HH:mm',
                                type: 'time',
                                disabled: true,
                                isRequired: true,
                            }}/>
                        <InputTimeBuilder
                            form={form}
                            formProps={props}
                            fieldSchema={{
                                label: 'Dividir em',
                                field: 'horaDivisao',
                                sizes: {
                                    xs: 12,
                                    md: 4,
                                },
                                format: 'HH:mm',
                                type: 'time',
                                isRequired: true,
                            }}/>
                        <InputTimeBuilder
                            form={form}
                            formProps={props}
                            fieldSchema={{
                                label: 'Fim',
                                field: 'horaFim',
                                sizes: {
                                    xs: 12,
                                    md: 4,
                                },
                                format: 'HH:mm',
                                type: 'time',
                                disabled: true,
                                isRequired: true,
                            }}/>
                    </>)
                }
            }
        </FormBuilder>);
}


SplitTempPendency.propTypes = {
    data: PropTypes.object,
    onSubmit: PropTypes.func,
    onCancel: PropTypes.func,
};

SplitTempPendency.defaultProps = {
    data: {}
};

export default SplitTempPendency;
